import Joi from '@hapi/joi'
export const BuyerAddEditSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select a Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select a Operatin Entity`,
        "any.required": `Operation Entity required`
    }),
    businessRegNo: Joi.string().max(20).required().label("Business RegNo ").messages({
        "string.pattern.base": `Please enter valid Business RegNo`,
        "string.max": `Please enter {#limit} characters.`,
        "any.required": `Business RegNo required`,
        "string.empty": `This field cannot be empty`
    }),
    buyerCode: Joi.string().invalid("0").required().label("Buyer Code ").messages({
        "any.required": `Buyer Code required`,
        "string.empty": `This field cannot be empty`,
        "any.invalid": `Cannot have 0 as supplier code`
    }),
    buyerName: Joi.string().required().label("Buyer Name").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Buyer Name`,
        "any.required": `Buyer Name required`
    }),
    buyerAddress: Joi.string().required().label("Buyer Address").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Buyer Address`,
        "string.max": `Please enter {#limit} characters.`,
        "any.required": `Buyer Address required`
    }),
    country: Joi.string().regex(/^[A-Za-z ]+$/).required().label("Country ").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Country`,
        "string.max": `Please enter {#limit} characters.`,
        "any.required": `Country  required`
    }),
    billingAddress: Joi.string().required().label("Billing Address ").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Billing Address`,
        "string.max": `Please enter {#limit} characters.`,
        "any.required": `Billing Address  required`
    }),
    contactNumber: Joi.string().regex(/^[0-9+]+$/).max(20).label("Contact Number ").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Contact Number`,
        "string.max": `Please enter {#limit} characters.`,
        "any.required": `Contact Number  required`
    }),
    email: Joi.string().email({ tlds: { allow: false } }).allow("",null).label("Email ").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Email`,
    }),
    companyPhone: Joi.string().regex(/^[0-9+]+$/).max(10).allow("",null).label("Company Phone ").messages({
        "string.pattern.base": `Please enter valid Company Phone`,
        "string.max": `Please enter {#limit} characters.`,
    }),
    companyFax: Joi.string().regex(/^[0-9+]+$/).max(10).allow("",null).label("Company Fax ").messages({
        "string.pattern.base": `Please enter valid Company Fax`,
        "string.max": `Please enter {#limit} characters.`,
    }),
    contactPersonName: Joi.string().allow("",null).label("Contact Person Name ").messages({
        "string.empty": `This field cannot be empty`,
        "string.pattern.base": `Please enter valid Contact Person Name`,
    }),
    creditPeriod: Joi.number().required().label("Credit Period").messages({
        "number.empty": `This field cannot be empty`,
        "any.required": `Please enter valid Credit Period`,
    }),
    creditAmount: Joi.number().required().label("Credit Amount").messages({
        "number.empty": `This field cannot be empty`,
        "any.required": `Please enter valid Contact Person`,
    }),
    isActive: Joi.boolean().label("Active"),
}

export const BuyerFilteringSchemaObject = {


    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select a Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select a Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
}

